<template>
  <div 
    :class="[
      'reports', 
      {'reports_cohort': metaView === 'cohort'}
    ]"
  >
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'Reports',
  data() {
    return {};
  },
  computed: {
    metaView() {
      return this.$route.meta.view;
    },
  },
};
</script>

<style lang="scss" scoped>
.reports{
  display: flex;
  flex-direction: column;


  &_cohort {
    .content-wrapper{
      height: 100%;
    } 
  }
}
</style>
